<template>
  <modal
    width="35"
    :show-modal="showModal"
    @close-modal="closeModal"
    title="Add New Account Manager"
  >
    <div>
      <label class="label">Name:</label>
      <input
        type="text"
        class="input"
        placeholder="Enter name"
        v-model="accountManager.name"
      />
    </div>
    <div>
      <label class="label">Phone number:</label>
      <input
        type="text"
        class="input"
        placeholder="Enter phone number"
        v-model="accountManager.phoneNumber"
      />
    </div>
    <div>
      <label class="label">Email address:</label>
      <email-input
        placeholder="Enter email address"
        v-model="accountManager.email"
      />
    </div>
    <div class="flex justify-between">
      <div>
        <p class="cursor-pointer" @click="closeModal">Cancel</p>
      </div>
      <div>
        <primary-button
          buttonText="Save"
          :loading="loading"
          @click="addAccountManager"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      accountManager: {
        name: "",
        phoneNumber: "",
        email: "",
      },
      loading: false,
    };
  },
  methods: {
    async addAccountManager() {
      this.loading = true;
      let orgId = localStorage.getItem("organizationId");
      this.accountManager.orgId = orgId;
      try {
        const response = await this.$_addAccountManager(this.accountManager);
        this.generateToast("Account Manager created!", "success");
        this.logResponse(response);
        this.$emit("account-manager-created");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style></style>
